import { exchangeApi } from './exchangeCurrency'

const CurrencyExchange = {
  convertCurrency: (from: string, to: string, amount: number) =>
    exchangeApi.get('/convert', { params: { from, to, amount } }),
}

export default CurrencyExchange
